import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import System from "@/pages/System";
import QBranch from "@/pages/QBranch";
import ShoeBoard from "@/pages/ShoeBoard";
import ResponsibleGambling from "@/pages/ResponsibleGambling";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/dossier" element={<Articles />} />
            <Route path="/dossier/:slug" element={<ArticleDetail />} />
            <Route path="/system" element={<System />} />
            <Route path="/q-branch" element={<QBranch />} />
            <Route path="/shoe-board" element={<ShoeBoard />} />
            <Route path="/responsible-gambling" element={<ResponsibleGambling />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121414",
            border: "1px solid #2a2d2d",
            color: "#F5F5F5",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
